export interface Features {
    gst: Feature,
    collabs: Feature,
    competitor: Feature & {
        uuid?: string
    },
}

export interface Feature extends FeatureProp {
    status: boolean
}

export interface FeatureProp {
    title: string;
    description: string;
    cta?: {
        text: string,
        link: string
    };
    key: string;
    colorClasses: string,
    sort_order: number
}

export interface DashboardState {
    features: {
        last_fetched_at: number,
        items: Features | null,
        completed: boolean,
        loading: boolean,
        error: string | null
    }
}

export const defaultFeatures: Features = {
    gst: {
        title: "Add GST details",
        description: "Complete wallet setup to launch your first campaign for which we will need your GST Details",
        cta: {text: "Add GST Details", link: "/wallet"},
        status: false,
        key: 'gst',
        colorClasses: 'bg-primary-subtle text-primary',
        sort_order: 3
    },
    collabs: {
        title: "Track your any creator collabs",
        description: "Track creator collaborations you did outside Influns and see all the data in one place.",
        cta: { text: "Track Creator Collabs", link: "/track-media" },
        status: false,
        key: 'collabs',
        colorClasses: 'bg-danger-subtle text-danger',
        sort_order: 2
    },
    competitor: {
        title: "Do 1 Competitive Analysis ",
        description: "See competitor brands, the influencers they work with, their posts, and more.",
        cta:{text:  "Track Competitors", link: '/competitor'},
        status: false,
        uuid: "",
        key: 'competitor',
        colorClasses: 'bg-info-subtle text-info',
        sort_order: 1
    }
}